import domain from '@framework/config/domain';
import config from '@drs/config';
import buildUrl from '@framework/url/helpers/buildUrl';
import base from '@framework/url/baseUrl';
import usersUrl from '@users/url';
import dmPortalUrl from '@dm-portal/url';
import appendConsentParams from '@framework/cookie-consent/appendConsentParams';

export default {
  /**
   * Get base DRS url
   */
  getUrl(...uris: (string | string[])[]): string {
    return buildUrl(domain.protocol, `${ config.hostname }`, ...uris);
  },

  /**
   * Get propagate url
   */
  getPropagateUrl(): string {
    return base.getRestUrl('/propagate');
  },

  /**
   * Get propagate with callback url as parameter
   */
  getPropagateCallbackUrl(callbackUrl: string): string {
    return `${ this.getPropagateUrl() }?callbackUrl=${ encodeURIComponent(callbackUrl) }`;
  },

  /**
   * Get base files url
   */
  getBaseFilesUrl(...uris: (string | string[])[]): string {
    return base.getApiUrl('dealroadshow/files', ...uris);
  },

  /**
   * Get file url
   */
  getFileUrl(...uris: (string | string[])[]): string {
    return this.getBaseFilesUrl(...uris);
  },

  /**
   * Get login url
   */
  getLoginUrl(): string {
    return appendConsentParams(usersUrl.getLoginUrl(
      this.getPropagateCallbackUrl(dmPortalUrl.getUrl('/roadshow')),
      config.code,
    ));
  },

  /**
   * Get login url for investor targeting
   */
  getLoginInvestorTargetingUrl(): string {
    return usersUrl.getLoginUrl(
      this.getPropagateCallbackUrl(dmPortalUrl.getUrl('/roadshow/investor-targeting')),
      config.code,
    );
  },

  /**
   * Get register url
   */
  getRegisterUrl(): string {
    return usersUrl.getRegisterUrl(
      this.getPropagateCallbackUrl(dmPortalUrl.getUrl('/roadshow')),
      config.code,
    );
  },

  /**
   * Get RPC url
   */
  getRpcUrl(): string {
    return base.getApiUrl('dealroadshow/rpc');
  },
};
